/* DLP · PDP buy box (Oct 2): pairs only, hide single-value options, short metal names */
(() => {
  const box = document.querySelector('.product__info');
  if (!box) return;
  /* earrings are sold as pairs: a "Single" page forwards to its pair */
  const sop = box.querySelector('.single-or-pair-options');
  if (sop) {
    const cur = sop.querySelector('div.single-or-pair-option');
    const pair = [...sop.querySelectorAll('a.single-or-pair-option')].find(a => /pair/i.test(a.textContent));
    if (cur && /single/i.test(cur.textContent) && pair) { location.replace(pair.href + location.search); return; }
  }
  const run = () => {
    box.querySelectorAll('variant-radios fieldset').forEach(f => f.classList.toggle('dlp-single-value', f.querySelectorAll('input[type=radio]').length === 1));
    box.querySelectorAll('fieldset.metal .tooltip').forEach(t => { const v = t.textContent.replace(/\s+gold\s*$/i, '').trim(); if (t.textContent !== v) t.textContent = v; });
    box.querySelectorAll('variant-radios fieldset legend > span:first-child').forEach(l => { const v = l.textContent.replace(/:\s*$/, ''); if (l.textContent !== v) l.textContent = v; });
  };
  run();
  new MutationObserver(run).observe(box, { childList: true, subtree: true, characterData: true });
})();
